export default __webpack_public_path__ + "static/media/brand5.e27cec18.svg";